module.exports = __webpack_public_path__ + "static/media/jcb.d075213a.svg";